import React from 'react'

import InputGroup from '../../../../UI/Forms/InputGroup/InputGroup'

const form = ({ form, inputChanged }) => {
  const formContent = Object.entries(form).map(item => {
    let [formKey, formAttrs] = item
    return (
      <InputGroup
        key={formKey}
        label={formAttrs.label}
        variant={'modal'}
        inputType={formAttrs.elementType}
        configs={formAttrs.elementConfig}
        invalid={!formAttrs.valid}
        validations={formAttrs.validation}
        touched={formAttrs.touched}
        changed={e => inputChanged(formKey, e)}
        inputValue={formAttrs.value}
        validationError={formAttrs.error}
      />
    )
  })
  return formContent
}

export default form
